<template>
  <section :class="getComponentClass(blok, animationClass)">
    <Scroll-view>
      <template slot-scope="featureListVisibility">
        <scroll-marker
          :key="blok._uid + '-list'"
          :name="blok._uid + '-list'"
          :visible="featureListVisibility[blok._uid + '-list']"
          :spacing="0"
          @isVisible="contentVisible = true"
        ></scroll-marker>
      </template>
    </Scroll-view>
    <div class="container">
      <template v-if="blok.sectionHeader && blok.sectionHeader[0]">
        <component
          :is="'m-sectionHeader' | dashify"
          :blok="blok.sectionHeader[0]"
          :theme="blok.theme"
        />
      </template>

      <h2 v-if="blok.title" class="features-list__title">
        {{ blok.title }}
      </h2>

      <ul class="features-list__list row">
        <li
          v-for="item in blok.list"
          :key="item._uid"
          :class="blok.grid"
          class="features-list__list-item"
        >
          <component
            :is="'m-feature-card' | dashify"
            :visible="contentVisible"
            :item="item"
            :class-modifier="
              blok.variation === 'article' ? 'feature-card--article' : ''
            "
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      contentVisible: false,
      animationClass: 'features-list--animate',
      isAnimationActive: true,
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
        if (this.isAnimationActive) {
          this.animationClass =
            'features-list--animate features-list--animate-done'
          this.isAnimationActive = false
        }
      }
    },
  },
  methods: {
    getComponentClass(blok, animationClass) {
      const base = 'features-list'
      const shadow = blok.hasShadow ? ' features-list--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      const theme = blok.theme ? blok.theme : ''
      const space = blok.space ? `space--${blok.space}` : 'space--small'
      let variation = ''
      switch (blok.variation) {
        case 'article':
          variation = 'features-list--article'
          break
        case 'title-heavy':
          variation = 'features-list--title-heavy'
          break
        default:
          variation = ''
      }

      return `${base} ${shadow} ${height} ${theme} ${variation} ${space} ${animationClass}`
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.features-list {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.h-default {
    min-height: 0;
  }

  &.theme-dark {
    background-image: linear-gradient(
      135deg,
      $grad-gradient 0%,
      $black 50%,
      $grad-gradient 100%
    );
  }

  .vue-scrollview__marker {
    margin-bottom: 0;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &--animate {
    .features-list__title {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }

    .features-list__list {
      opacity: 0;
      transition: opacity 0.7s;
      transition-delay: 0.4s;
    }
  }

  &--animate-done {
    .features-list__title {
      transform: translate(0, 0);
      opacity: 1;
    }
    .features-list__list {
      opacity: 1;
    }
  }

  &--article {
    // no transitions on article page because we animate the numbers there
    .features-list__title {
      transition: none;
      opacity: 1;
      transform: translate(0, 0);
    }

    .features-list__list {
      margin-top: 0;
      transition: none;
      opacity: 1;
    }
  }

  .section-header {
    margin-bottom: 15px;
  }

  &__title {
    @include font-size(36);
    @include font-family($font-family-headings-bold, $headings-font-weight);

    margin: 0;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin-top: 70px;
    margin-bottom: 0;
  }
}

@include media-breakpoint-up(md) {
  .features-list .section-header {
    margin-bottom: 75px;
  }
}

@include media-breakpoint-up(lg) {
  .features-list {
    &__title {
      width: 67%;
    }
  }

  .features-list--title-heavy {
    .features-list__title {
      @include font-size(83, rem-v(96));

      width: 100%;
    }
  }
}
</style>
